import './Section.css';
import { useState, useEffect } from 'react';
import CryptoJS from 'crypto-js'; // Importa a biblioteca CryptoJS

// Chave secreta para criptografar/descriptografar os dados
const SECRET_KEY = 'minha-chave-secreta';

export const Section = () => {
    const [task, setTask] = useState('');

    // Função para criptografar dados
    const encryptData = (data) => {
        return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
    };

    // Função para descriptografar dados
    const decryptData = (data) => {
        const bytes = CryptoJS.AES.decrypt(data, SECRET_KEY);
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    };

    // Estado de tarefas com localStorage (descriptografando ao carregar)
    const [tasks, setTasks] = useState(() => {
        try {
            const tasksSaved = localStorage.getItem('@tasks');
            return tasksSaved ? decryptData(tasksSaved) : [];
        } catch (error) {
            console.error('Erro ao carregar tarefas do localStorage:', error);
            return [];
        }
    });

    // Estado para controle da modal de erro
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    // Atualiza o localStorage quando `tasks` mudar (criptografando antes de salvar)
    useEffect(() => {
        try {
            const encryptedTasks = encryptData(tasks);
            localStorage.setItem('@tasks', encryptedTasks);
        } catch (error) {
            console.error('Erro ao salvar tarefas no localStorage:', error);
        }
    }, [tasks]);

    // Função para adicionar uma nova tarefa
    function handleFormulaire(e) {
        e.preventDefault();

        if (!task.trim()) {
            setErrorMessage('Por favor, insira uma tarefa válida!');
            setShowErrorModal(true);
            return;
        }

        const specialChars = /[!@#$%^&*(),.?":{}|<>]/;
        if (specialChars.test(task)) {
            setErrorMessage('Tarefa não pode conter caracteres especiais!');
            setShowErrorModal(true);
            return;
        }

        const taskSet = new Set(tasks.map(item => item.toLowerCase()));
        if (taskSet.has(task.trim().toLowerCase())) {
            setErrorMessage('Tarefa já existe na lista!');
            setShowErrorModal(true);
            return;
        }

        const taskWithCapital = task.charAt(0).toUpperCase() + task.slice(1).toLowerCase();

        setTasks(prevTasks => [...prevTasks, taskWithCapital]);
        setTask('');
    }

    function removeTask(index) {
        const updatedTasks = tasks.filter((_, i) => i !== index);
        setTasks(updatedTasks);
    }

    function closeErrorModal() {
        setShowErrorModal(false);
    }

    function handleChange(e) {
        const value = e.target.value;
        const sanitizedValue = value.replace(/[!@#$%^&*(),.?":{}|<>]/g, '');
        setTask(sanitizedValue);
    }

    return (
        <section className="section">
            <h2 className="section__title">Digite a sua tarefa</h2>
            <div className="form">
                <form onSubmit={handleFormulaire}>
                    <label>
                        Tarefa:
                        <input
                            type="text"
                            value={task}
                            onChange={handleChange}
                            placeholder="Digite sua tarefa!"
                            maxLength={40}
                        />
                    </label>
                    <button className="btn" type="submit">
                        Salvar
                    </button>
                </form>
            </div>

            {showErrorModal && (
                <div className="modal">
                    <div className="modal-content">
                        <span className="close" onClick={closeErrorModal}>&times;</span>
                        <p>{errorMessage}</p>
                    </div>
                </div>
            )}

            <div className="data-tarefas">
                <div className="title-tarefas">
                    <h3>
                        Tarefas Pendentes
                        {tasks.length > 0 && ` (${tasks.length})`}
                    </h3>
                </div>
                <div className="tasks">
                    {tasks.length === 0 ? (
                        <p className="no-tasks-message">Não existem tarefas.</p>
                    ) : (
                        <ul>
                            {tasks.map((item, key) => (
                                <li key={key}>
                                    {item}
                                    <button
                                        className="btnRemove"
                                        onClick={() => removeTask(key)}
                                    >
                                        Apagar
                                    </button>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>
        </section>
    );
};
